import commonTracker from './common/commonTracker'
import homeTracker from './home/homeTracker'
import helpCenterTracker from './helpCenter/helpCenterTracker'
import lineMaintainTracker from './lineMaintain/lineMaintainTracker'
import consultationTracker from './consultation/consultationTracker'
import monthlySettleTracker from './monthlySettle/monthlySettleTracker'
import smileSingleTracker from './smileSingle/smileSingleTracker'
import bankAccountTracker from './bankAccount/bankAccountTracker'
import accountManageTracker from './accountManage/accountManageTracker'
import addressManageTracker from './addressManage/addressManageTracker'
import intelligentTracker from './intelligent/intelligentTracker'

export const PORTAL_TRACKER_KEY_MAP: {
  [prop: string]: any
} = {
  ...homeTracker, // 首页埋点
  ...commonTracker, // 公用埋点
  ...lineMaintainTracker, // 航线维护埋点
  ...consultationTracker, // 咨询单埋点
  ...helpCenterTracker, // 帮助中心
  ...monthlySettleTracker, // 月结验证方式设置
  ...smileSingleTracker, // 微笑面单设置
  ...bankAccountTracker, // 银行信息维护
  ...accountManageTracker, // 账号管理
  ...addressManageTracker, // 地址簿管理
  ...intelligentTracker // 产品智能导购
}
